<template>
 <div class="smallDialogWrap">
  <el-dialog title="" :visible.sync="visible" @close="closeDialog">
    <div v-if="type == 2" class="topTit">
      {{ tit }}
    </div>

    <template v-if="type == 2">
      <img class="tipImg" src="../assets/images/cg2.png" />
    </template>
    <template v-else>
      <img class="tipImg" src="../assets/images/cg@2x.png" />
    </template>

    <div class="tip">{{tip}}</div>
    <template v-if="type == 2">
      <span class="blueBtn blueBtn2" @click="goHome">返回首页<span>（{{count}}S后自动跳转）</span></span>
    </template>
    <template v-else>
      <div class="btns">
        <span class="greyBtn" @click="closeDialog">取消</span>
        <span class="blueBtn" @click="goConsole">去控制台查看详情</span>
      </div>
    </template>

  </el-dialog>
  </div>
</template>
<script>
 import {
    fetchApplicationApply
  } from '@/api/api'
  export default {
    data() {
      return {
        visible: false,
        show: true,
        count: '',
        timer: null,
      }
    },
    props: ['tip','name', 'type', 'tit'],
    created() {
      // this.getCode()
    },
    methods: {
      getCode(){
          const TIME_COUNT = 5;
          if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                  } else {
                      this.show = true;
                      this.goHome()
                      clearInterval(this.timer);
                      this.timer = null;
                  }
              }, 1000)
          }
      },
      closeDialog() {
         this.visible= false
      },
      openDialog(val) {
        this.visible= true
        if(this.type ==2) {
          this.getCode()
        }
      },
      goConsole() {
        this.$router.push({
          name: this.name
        })
      },
      goHome() {
        this.$router.push({
          path: '/home'
        })
      }
    }
  }
</script>
<style scoped>
  .smallDialogWrap /deep/  .el-dialog {
    width: 580px;
    height: 450px;
    position: relative;
    border-radius: 20px;
    background: #fff ;
  }

  .smallDialogWrap /deep/ .el-dialog__header {
    width: 476px;
    margin: 0 auto;
  }

  .smallDialogWrap /deep/ .el-dialog__title {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0A0909;
    line-height: 37px;
  }

 .greyBtn{
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #A7AFC3;
    background: #E8EDF6;
    border-radius: 23px;
    width: 220px;
    display: inline-block;
    text-align: center;
    padding: 10px 0;
    cursor: pointer;
 }
 .blueBtn{
   font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  background: #0F5EFF;
  border-radius: 23px;
  width: 220px;
    display: inline-block;
    text-align: center;
    padding: 10px 0;
    cursor: pointer;
 }
 .btns{
   display: flex;
   justify-content: space-evenly;
 }
 .tip{
   font-size: 18px;
    color: rgba(10, 9, 9, 1);
    text-align: center;
    margin-top: 20px;
    margin-bottom: 70px;
    font-weight: normal;
    font-family: PingFangSC-Regular, PingFang SC;
 }
 .tipImg{
   width: 118px;
   margin: 65px auto 0;
   display: block;
 }
 .topTit{
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0A0909;
  text-align: center;
 }
 .blueBtn span {
   color: rgba(157, 189, 255, 1);
 }
 .blueBtn2{
   display: block;
   margin: 0 auto;
 }
</style>



// WEBPACK FOOTER //
// src/components/smallDialog.vue